import React from 'react';
import { Box, Heading, Text, VStack, SimpleGrid, Flex } from '@chakra-ui/react';
import { FaHome, FaClipboardList, FaWallet, FaChartLine, FaBell, FaExchangeAlt, FaCog, FaShoppingBasket } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const orders = [
  {
    user: 'user1',
    items: [
      {
        itemName: 'Item 1',
        price: 10,
      },
      {
        itemName: 'Item 2',
        price: 15,
      },
      // Add more items here
    ],
    totalAmount: 25,
    status: 'Pending',
    timestamp: new Date(),
    preferredOrderTime: new Date(),
  },
  // Add more orders here
];

const RestaurantOrder = () => {
  return (
    <Box bg="gray.50" p={8}>
      <Box bg="white" p={4} borderRadius="md" mb={4}>
        <Heading color="blue.200">Orders</Heading>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
        {orders.map((order, index) => (
          <Box
            key={index}
            bg="white"
            p={4}
            borderRadius="xl" // Border radius of 45
            boxShadow="md"
            transition="transform 0.2s ease-in-out" // Transition for hover effect
            _hover={{ transform: 'translateY(-5px)' }} // Hover effect
          >
            <VStack spacing={2}>
              <Text color="blue.200" fontWeight="bold">
                Order {index + 1}
              </Text>
              <Text color="blue.200">Total: ${order.totalAmount.toFixed(2)}</Text>
              <Text color="blue.200">Status: {order.status}</Text>
              <Text color="blue.200">Timestamp: {order.timestamp.toString()}</Text>
              <Text color="blue.200">Preferred Order Time: {order.preferredOrderTime.toString()}</Text>
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
            {/* Bottom Navigation for Mobile */}
            <Flex
          bg="blue.200"
          p={2}
          mt={4}
          align="center"
          justify="space-between"
          position="fixed"
          bottom={0}
          mx="auto"
          width="95%"
          display={{ base: 'flex', md: 'none' }} // Hide on larger screens
        >
            <Box textAlign="center" flex="1" p={2}>
              <Link to="restaurant">
                  <Flex alignItems="center" flexDirection="column">
                  <FaHome />
                  <Text color="white" fontSize="xs" mt={1}>
                      Home
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-orders">
                  <Flex alignItems="center" flexDirection="column">
                  <FaClipboardList />
                  <Text color="white" fontSize="xs" mt={1}>
                      Orders
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-market-place">
                  <Flex alignItems="center" flexDirection="column">
                  <FaShoppingBasket />
                  <Text color="white" fontSize="xs" mt={1}>
                      Market
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/restaurant-analytics">
                <Flex alignItems="center" flexDirection="column">
                <FaChartLine />
                <Text color="white" fontSize="xs" mt={1}>
                    Analytics
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-wallet">
                  <Flex alignItems="center" flexDirection="column">
                  <FaWallet />
                  <Text color="white" fontSize="xs" mt={1}>
                      Wallet
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-trades">
                  <Flex alignItems="center" flexDirection="column">
                  <FaExchangeAlt />
                  <Text color="white" fontSize="xs" mt={1}>
                      Trades
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-notifications">
                  <Flex alignItems="center" flexDirection="column">
                  <FaBell />
                  <Text color="white" fontSize="xs" mt={1}>
                      Notifications
                  </Text>
                  </Flex>
              </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
              <Link to="/restaurant-settings">
                  <Flex alignItems="center" flexDirection="column">
                  <FaCog />
                  <Text color="white" fontSize="xs" mt={1}>
                      Settings
                  </Text>
                  </Flex>
              </Link>
            </Box>   
        </Flex>
        
    </Box>
  );
};

export default RestaurantOrder;
